import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Grid, Icon } from '../../../shared';
import { NoGridData } from '../../../shared';
import { services } from '../../../../../src/shared/index';
import { formStatusName, loaderConstant } from '../../../../shared/types/constants';
import { saveAs } from 'file-saver';
import './illustration-table.scss';
import { LoaderWrapper } from '../../../../shared/utils/loader/loader-wrapper';
import { useLoader } from '../../../../shared/utils';
export var IllustrationTable = function (_a) {
    var esisSummary = _a.esisSummary, editPage = _a.editPage, caseId = _a.caseId;
    var _b = useState(false), isDownloading = _b[0], setIsDownloading = _b[1];
    var dowloadIllustration = function (esisDocumentId) {
        setIsDownloading(true);
        services.getDownloadIllustration(esisDocumentId).then(function (blob) {
            saveAs(blob, "Illustration-".concat(caseId, ".pdf"));
            setIsDownloading(false);
        });
    };
    var illustrationDocumentsTableIsLoading = useLoader({ identifier: 'illustrationDocumentsTable' }).illustrationDocumentsTableIsLoading;
    var columns = [
        {
            id: 'description',
            description: 'Product',
        },
        {
            id: 'productTerm',
            description: 'Product Term',
        },
        {
            id: 'productTypeId',
            description: 'Product Type',
            sort: false,
            render: function (column, row) {
                return React.createElement(React.Fragment, null, row[column.id] === 1 ? 'Fixed' : 'Variable');
            },
        },
        {
            id: 'download',
            description: '',
            sort: false,
            render: function (column, row) {
                var _a;
                if (((_a = row.documentId) !== null && _a !== void 0 ? _a : 0) > 0 &&
                    (row.status == formStatusName.completed || row.status == formStatusName.passed)) {
                    return (React.createElement(Button, { type: "button", variant: "secondary", icon: "download", iconPosition: "left", disabled: isDownloading, onClick: function () { return dowloadIllustration(row.documentId); } }, "Download"));
                }
                else {
                    return React.createElement("span", { className: "c-btn c-btn--error" }, "Error");
                }
            },
        },
        {
            id: 'edit',
            description: '',
            sort: false,
            render: function (column, row) {
                return (React.createElement(Link, { to: editPage !== null && editPage !== void 0 ? editPage : '/', className: "c-btn c-btn--secondary" },
                    React.createElement("div", { className: "c-illustration-table-edit-button" },
                        React.createElement(Icon, { name: "illustration", colour: "primary" })),
                    "Edit"));
            },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(LoaderWrapper, { type: "table", count: 1, identifier: "illustrationDocumentsTable" },
            React.createElement(Grid, { columns: columns, rowData: illustrationDocumentsTableIsLoading ? [] : esisSummary !== null && esisSummary !== void 0 ? esisSummary : [], noRowsMessage: React.createElement(NoGridData, { image: "no-clients", message: illustrationDocumentsTableIsLoading ? loaderConstant.loadingText : 'You currently have no illustrations' }), showHeaders: esisSummary && esisSummary.length > 0, defaultDirection: "Desc", defaultSortColumn: "applicationId" }))));
};
